import request from './request';

const auth = {
	async requestAuthOtp(body) {
		const response = await request.post('/app/auth/login/send-otp', body);
		return response;
	},
	async verifyAuthOtp(body) {
		const response = await request.post('/app/auth/login/verify-otp', body);
		return response;
	},
	async requestSignUpOtp(body) {
		const response = await request.post('/app/auth/create/send-otp', body);
		return response;
	},
	async verifySignUpOtp(body) {
		const response = await request.post('/app/auth/create/verify-otp', body);
		return response;
	},
	async logout() {
		const res = await request.post('/app/auth/logout');
		return res;
	}
};

export default auth;

